import Link from 'next/link'
import React from 'react'
import { Metadata } from 'next';
import urls from '@/utils/urls/urls';
import AnimationWrapper from '../AnimationWrapper/AnimationWrapper';

export const metadata: Metadata = {
    title: 'Products | TEX EXCELLENCE LIMITED',
    description: 'Products | TEX EXCELLENCE LIMITED',
}

const ProductsByCategory = async ({ params }: { params: { product_category: string } }) => {
    let products = [];
    let brands = [];

    try {
        const res = await fetch(urls?.productCategoryOne + '/' + params?.product_category, {
            cache: 'no-store'
        })
        
        if (res.ok) {
            const contentType = res.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                try {
                    const data = await res.json()
                    products = data?.data?.product ?? [];
                } catch (parseError) {
                    console.error('Error parsing products by category JSON:', parseError);
                    products = [];
                }
            }
        }
    } catch (error) {
        console.error('Error fetching products by category:', error);
        products = [];
    }

    try {
        const resBrand = await fetch(urls?.brand, {
            cache: "no-store"
        })
        
        if (resBrand.ok) {
            const contentType = resBrand.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                try {
                    const dataBrand = await resBrand.json()
                    brands = Array.isArray(dataBrand?.data) ? dataBrand?.data : [];
                } catch (parseError) {
                    console.error('Error parsing brands JSON:', parseError);
                    brands = [];
                }
            }
        }
    } catch (error) {
        console.error('Error fetching brands:', error);
        brands = [];
    }
    // console.log(brands)
    return (
        <div>
            <>
                {/* sidebar-popup end */}
                <main className="main">
                    {/* breadcrumb */}
                    <div
                        className="site-breadcrumb"
                        style={{ background: "url(assets/img/breadcrumb/01.jpg)" }}
                    >
                        <div className="container">
                            <h2 className="breadcrumb-title">Products</h2>
                            <ul className="breadcrumb-menu">
                                <li>
                                    <Link href="/">Home</Link>
                                </li>
                                <li className="active">Products</li>
                            </ul>
                        </div>
                    </div>
                    {/* breadcrumb end */}
                    {/* service area */}
                    {
                        products?.length > 0 ?
                            <div className="service-area bg py-100">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-6 mx-auto">
                                            <div
                                                className="site-heading text-center wow fadeInDown"
                                                data-wow-delay=".25s"
                                            >
                                                <span className="site-title-tagline">
                                                    <i className="far fa-solar-panel" /> Products
                                                </span>
                                                <h2 className="site-title">
                                                    What Products we are <span>providing</span> to you
                                                </h2>
                                                <div className="heading-divider" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12 d-flex justify-content-center gap-4 align-items-center mb-4">
                                            {
                                                brands.map((brand: any) => (
                                                    <a key={brand?.id} href={brand?.product_link} target='_blank' >
                                                        <img
                                                            src={urls?.image + brand?.logo} alt="thumb" className=""
                                                            // width={250} // Desired width of the image
                                                            // height={50} // Desired height of the image

                                                            style={{
                                                                objectFit: "fill",
                                                                width: "200px",
                                                                height: "120px",
                                                                borderRadius: "10px",
                                                            }}
                                                        />

                                                    </a>
                                                ))
                                            }
                                        </div>
                                    </div>
                                    <AnimationWrapper animation="fade-up">
                                        <div className="row g-4 wow fadeInUp" data-wow-delay=".25s">
                                            {
                                                products?.length > 0 ? products?.map((product: any, index: number) => (
                                                    <div className="col-md-6 col-lg-3" key={product?.id}>
                                                        <div className="service-item">
                                                            <span className="count">{(index + 1).toString().padStart(2, '0')}</span>
                                                            <div >
                                                                <img className="service-img" src={urls?.image + product?.image} alt="" />
                                                            </div>
                                                            <div className="service-icon">
                                                                <img src="assets/img/icon/solar.svg" alt="" />
                                                            </div>
                                                            <div className="service-content">
                                                                <h4 className="service-title">
                                                                    <Link href={`/products/${product?.id}`}>{product?.name}</Link>
                                                                </h4>
                                                                <p className="service-text ">
                                                                    {product?.description && <div dangerouslySetInnerHTML={{ __html: product?.description?.slice(0, 90) }} />}
                                                                </p>
                                                                <Link href={`/products/${product?.id}`} className="theme-btn theme-btn-card">
                                                                    Learn More
                                                                    <i className="fas fa-arrow-right" />
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )) : 'No Data Found'
                                            }
                                        </div>
                                    </AnimationWrapper>
                                </div>
                            </div> : <span 
                            className='d-flex justify-content-center align-items-center' style={{
                                minHeight: "100px",
                            }}>
                                No Data Found
                            </span>
                    }

                    {/* service area end */}
                </main>
                {/* footer area */}
                {/* <footer className="footer-area">
                    <div className="footer-shape">
                        <img src="assets/img/shape/08.png" alt="" />
                    </div>
                    <div className="footer-widget">
                        <div className="container">
                            <div className="footer-widget-wrap pt-100 pb-80">
                                <div className="row g-4">
                                    <div className="col-lg-5">
                                        <div className="footer-widget-box about-us">
                                            <Link href="#" className="footer-logo">
                                                <img src="assets/img/logo/logo-light.png" alt="" />
                                            </Link>
                                            <p className="mb-4">
                                                We are many variations of passages available but the majority
                                                have suffered alteration some form by injected humour words
                                                believable.
                                            </p>
                                            <div className="footer-newsletter">
                                                <h6>Subscribe Our Newsletter</h6>
                                                <div className="newsletter-form">
                                                    <form action="#">
                                                        <div className="form-group">
                                                            <div className="form-icon">
                                                                <i className="far fa-envelopes" />
                                                                <input
                                                                    type="email"
                                                                    className="form-control"
                                                                    placeholder="Your Email"
                                                                />
                                                                <button className="theme-btn" type="submit">
                                                                    Subscribe <span className="far fa-paper-plane" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-lg-2">
                                        <div className="footer-widget-box list">
                                            <h4 className="footer-widget-title">Company</h4>
                                            <ul className="footer-list">
                                                <li>
                                                    <Link href="about">
                                                        <i className="far fa-angle-double-right" />
                                                        About Us
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link href="blog">
                                                        <i className="far fa-angle-double-right" />
                                                        Update News
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link href="testimonial">
                                                        <i className="far fa-angle-double-right" />
                                                        Testimonials
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link href="contact">
                                                        <i className="far fa-angle-double-right" />
                                                        Contact Us
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link href="terms">
                                                        <i className="far fa-angle-double-right" />
                                                        Terms Of Service
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link href="privacy">
                                                        <i className="far fa-angle-double-right" />
                                                        Privacy policy
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-6 col-lg-2">
                                        <div className="footer-widget-box list">
                                            <h4 className="footer-widget-title">Services</h4>
                                            <ul className="footer-list">
                                                <li>
                                                    <Link href="service">
                                                        <i className="far fa-angle-double-right" />
                                                        Solar Panels
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link href="service">
                                                        <i className="far fa-angle-double-right" />
                                                        Wind Generators
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link href="service">
                                                        <i className="far fa-angle-double-right" />
                                                        Easy Installation
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link href="service">
                                                        <i className="far fa-angle-double-right" />
                                                        Solar Maintenance
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link href="service">
                                                        <i className="far fa-angle-double-right" />
                                                        Hydraulic Power
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link href="service">
                                                        <i className="far fa-angle-double-right" />
                                                        Fossil Resources
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="footer-widget-box">
                                            <h4 className="footer-widget-title">Get In Touch</h4>
                                            <ul className="footer-contact">
                                                <li>
                                                    <div className="icon">
                                                        <i className="far fa-location-dot" />
                                                    </div>
                                                    <div className="content">
                                                        <h6>Our Address</h6>
                                                        <p>25/AB Milford Road, New York, USA</p>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="icon">
                                                        <i className="far fa-phone" />
                                                    </div>
                                                    <div className="content">
                                                        <h6>Call Us</h6>
                                                        <Link href="tel:"></Link>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className="icon">
                                                        <i className="far fa-envelope" />
                                                    </div>
                                                    <div className="content">
                                                        <h6>Mail Us</h6>
                                                        <Link href="https://live.themewild.com/cdn-cgi/l/email-protection#1c75727a735c79647d716c7079327f7371">
                                                            <span
                                                                className="__cf_email__"
                                                                data-cfemail="c7aea9a1a887a2bfa6aab7aba2e9a4a8aa"
                                                            >
                                                                email
                                                            </span>
                                                        </Link>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="copyright">
                            <div className="row">
                                <div className="col-md-6 align-self-center">
                                    <p className="copyright-text">
                                        © Copyright <span id="date" /> <Link href="#"> Solario </Link> All
                                        Rights Reserved.
                                    </p>
                                </div>
                                <div className="col-md-6 align-self-center">
                                    <ul className="footer-social">
                                        <li>
                                            <Link href="#">
                                                <i className="fab fa-facebook-f" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#">
                                                <i className="fab fa-x-twitter" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#">
                                                <i className="fab fa-linkedin-in" />
                                            </Link>
                                        </li>
                                        <li>
                                            <Link href="#">
                                                <i className="fab fa-youtube" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer> */}
                {/* footer area end */}
                {/* scroll-top */}
                <Link href="#" id="scroll-top">
                    <i className="far fa-arrow-up" />
                </Link>
                {/* scroll-top end */}
                {/* js */}
            </>

        </div>
    )
}

export default ProductsByCategory
